module.exports = __webpack_public_path__ + "img/person-placeholder.6e2b4918.png";